import { round } from '../backtest/utils'
import BarChart, { Bar } from './barChart'

function convertData(endYear: number, values: any[]) {
  return values
    .map((value, index) => ({
      name: endYear - index,
      value,
    }))
    .reverse() as unknown as Bar[]
}

interface FAChartProps {
  id: string
  largeRoundPlaces: number
  largeScale: number
  largeTitleSufix: string
  smallRoundPlaces: number
  smallScale: number
  smallTitleSufix: string
  title: string
}

function FAChart({
  id,
  title,
  smallRoundPlaces,
  largeRoundPlaces,
  smallScale,
  largeScale,
  smallTitleSufix,
  largeTitleSufix,
}: FAChartProps) {
  const data: number[] = FinvizFA[id]

  const min = Math.min(...data)
  const max = Math.max(...data)
  const range = max > -min ? max : -min

  const isLarge = Math.abs(range) >= 1000

  const scale = isLarge ? largeScale : smallScale
  const values = data.map((value) =>
    value == null ? null : round(scale * value, isLarge ? largeRoundPlaces : smallRoundPlaces)
  )

  return (
    <BarChart
      title={title + ' ' + (isLarge ? largeTitleSufix : smallTitleSufix)}
      data={convertData(FinvizFA.year, values)}
      valueFormatter={(value) => round(value, isLarge ? largeRoundPlaces : smallRoundPlaces)}
      width={280}
      height={150}
      marginRight={37}
      className="is-fa"
    />
  )
}

export default function FundamentalCharts() {
  return (
    <>
      <td align="center">
        <FAChart
          id="1"
          title="EPS"
          smallRoundPlaces={2}
          largeRoundPlaces={0}
          smallScale={1}
          largeScale={1}
          smallTitleSufix=""
          largeTitleSufix=""
        />
      </td>
      <td align="center">
        <FAChart
          id="2"
          title="Sales"
          smallRoundPlaces={2}
          largeRoundPlaces={2}
          smallScale={1}
          largeScale={0.001}
          smallTitleSufix="($mln)"
          largeTitleSufix="($bln)"
        />
      </td>
      <td align="center">
        <FAChart
          id="3"
          title="Shares Outstanding"
          smallRoundPlaces={2}
          largeRoundPlaces={2}
          smallScale={1}
          largeScale={0.001}
          smallTitleSufix="(mln)"
          largeTitleSufix="(bln)"
        />
      </td>
    </>
  )
}
